import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import useStyles, {
  aboutDrawerWidth,
  chartTogglebarWidth,
} from "../Styles";
import HighchartsReact from "highcharts-react-official";
import { Box, Slider, Tooltip, Typography, Grid } from "@material-ui/core";
import userActions from "../actions";
import CentralAZLocationFilter from "../CentralAZLocationFilter";
import highchartsMore from "highcharts/highcharts-more.js";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge";
import { getWindowSize, sliderValues } from "../utils";
import { useSelector } from "react-redux";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import "rc-tooltip/assets/bootstrap_white.css";
import "./gaugePie.css";
import { useLocation } from "react-router";

highchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

const valueLabelFormat = (value) => {
  const num = value;

  if (typeof value !== "number") {
    return value;
  }
  return num
};

const ValueLabelComponent = (props) => {
  // const { loggedIn } = useSelector((state) => state.auth);
  const classes = useStyles();
  const { children, value } = props;
  const title = valueLabelFormat(value);

  return (
    <Tooltip
      placement="top"
      arrow
      title={title}
      open={true}
      classes={{
        tooltip: classes.technicalTooltipPopper,
      }}
    >
      {children}
    </Tooltip>
  );
};

function GaugePie() {
  const classes = useStyles();
  const [windowSize, setWindowSize] = useState(getWindowSize());
  // const [sliderValue, setSliderValue] = useState(100);
  const {
    cities,
    city_metrics,
    entity_entitlements,
    entitlement_year,
    slider_entitlement_year,
    city_selected,
    scenario_selected,
    // slider_range,
  } = useSelector((state) => state.technical_view);
  const { loggedIn } = useSelector((state) => state.auth);
  const [minimumAccess, setMinimumAccess] = useState(0);
  const [maximumAccess, setMaximumAccess] = useState(0);
  const [options, setOptions] = useState(null);
  const [isSectorFull, setIsSectorFull] = useState(false);
  const { isMobile } = useGetViewPortDimensions();
  const {
    setEntitlementYear,
    setSliderEntitlementYear,
    setSelectedCity,
    loadCityMetrics,
    loadEntityEntitlements,
    setIsWesternEntity,
    setIsCity,
    setIsTribe,
    // resetSelectedCity,
  } = userActions();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dropdown = params.get('dropdown');

  //gets windowSize to set width of barchart
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    if(dropdown && cities?.length) {
      var entityFound = cities.find((item) => item?.label?.toLowerCase() === (dropdown?.toLowerCase()));
      if(entityFound) {
        setSelectedCity(entityFound)
        loadCityMetrics(entityFound?.value);
        loadEntityEntitlements(entityFound?.value, scenario_selected?.value);
        setIsWesternEntity(false);
        setIsCity(true);
        setIsTribe(false);
      }
    }
  }, [dropdown, cities])

  // useEffect(() => {
  //   return () => {
  //     resetSelectedCity();
  //     loadEntityEntitlements(1);
  //     loadCityMetrics(1);
  //   };
  // }, []);

  useEffect(() => {
    if (Object.keys(entity_entitlements).length) {
      let minimum = Infinity;
      let maximum = -Infinity;
      Object.keys(entity_entitlements).forEach((year) => {
        minimum = Math.min(minimum, entity_entitlements[year].total_co_access);
        maximum = Math.max(maximum, entity_entitlements[year].total_co_access);
      });
      setMinimumAccess(minimum);
      setMaximumAccess(maximum);
    }
  }, [entity_entitlements]);

  Highcharts.setOptions({
    chart: {
      style: {
        fontFamily: "Arial",
        fontSize: "14px",
      },
    },
  });

  const loadEntitlements = () => {
    loadEntityEntitlements(city_selected.city_id, scenario_selected.value);
  }
  useEffect(loadEntitlements, [scenario_selected]);

  const findElement = () => {
    const data = [
      Math.round(city_metrics.tap_colorado_percent * 100),
      Math.round(city_metrics.exchange_colorado_percent * 100),
      Math.round(city_metrics.turf_colorado_percent * 100),
      Math.round(city_metrics.agriculture_colorado_percent * 100),
      Math.round(city_metrics.aquifer_recharge_colorado_percent * 100),
    ];
    const foundEle = data.find((ele) => ele === 100);
    if (foundEle !== undefined) {
      setIsSectorFull(true);
    } else {
      setIsSectorFull(false);
    }
  }
  useEffect(findElement, [city_metrics]);


  const setOptionFunc = () => {
    let pieChartData = [
      {
        name: "Tap",
        y: Math.round(city_metrics.tap_colorado_percent * 100),
        color: "#2352D0",
      },
      {
        name: "Exchange",
        y: Math.round(city_metrics.exchange_colorado_percent * 100),
        color: "#96D9E4",
      },
      {
        name: "Turf Facilities",
        y: Math.round(city_metrics.turf_colorado_percent * 100),
        color: "#43B99E",
      },
      {
        name: "Agriculture (GSF)",
        y: Math.round(city_metrics.agriculture_colorado_percent * 100),
        color: "#DE3E40",
      },
      {
        name: "Recharge",
        y: Math.round(
          city_metrics.aquifer_recharge_colorado_percent * 100
        ),
        color: "#FFB607",
      },
    ]
    let filteredData = pieChartData.filter((p) => p?.y !== 0)
    const options_temp = {
      chart: {
        // type: "solidgauge",
        plotBackgroundColor: "transparent",
        backgroundColor: "transparent",
        borderColor: "#EBBA95",
        //   borderWidth: 5,
        // plotBorderWidth: 2,
        height:
          !isMobile &&
          windowSize.innerHeight - 250,
        width: isMobile
          ? Math.min(windowSize.innerWidth - 40, 400)
          : windowSize.innerWidth - aboutDrawerWidth - chartTogglebarWidth - 80,
        margin: 40,
        style: {
          fontFamily: "Arial",
        },
      },
      title: {
        text: Object.keys(city_metrics).length === 0? "Results coming soon": undefined,
        verticalAlign: "middle",
      },
      pane: {
        center: ["50%", "50%"],
        size: "100%",
        startAngle: 0,
        endAngle: 350,
        background: {
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || "#EEE",
          innerRadius: "85%",
          outerRadius: "95%",
          shape: "arc",
        },
      },
      yAxis: {
        // stops: [
        //     [0.1, '#55BF3B'], // green
        //     [0.5, '#DDDF0D'], // yellow
        //     [0.9, '#DF5353'] // red
        // ],
        lineWidth: 0,
        tickWidth: 0,
        minorTickInterval: null,
        tickAmount: 17,
        // tickPixelInterval: 40,
        min: 0,
        max: maximumAccess,

        labels: {
          distance: 10,
          style: {
            fontSize: "14px",
          },
          formatter: function () {
            // Format labels greater than 10,000 as "10k"(Curve-407)
            const formattedLabel = this.value >= 10000 ? Highcharts.numberFormat(this.value / 1000, 1) + 'k' : this.value;
            return formattedLabel;
          },
        },
      },
      series: [
        {
          type: "pie",
          name: "Colorado Water Usage",
          innerSize: "0%",
          dataLabels: {
            style: {
              fontSize: "9px",
            },
          },
          data: filteredData,
        },
        {
          type: "solidgauge",
          name: "Amount of Water Available",
          title: "none",
          data: [
            {
              radius: "95%",
              innerRadius: "85%",
              y: entity_entitlements[entitlement_year]
                ? entity_entitlements[entitlement_year].total_co_access
                : 0,
            },
          ],
          dataLabels: {
            // format:
            //   '<div style="text-align:center">' +
            //   '<span style="font-size:25px">{y}</span><br/>' +
            //   '<span style="font-size:12px;opacity:0.4">km/h</span>' +
            //   "</div>"
            enabled: false,
          },
          tooltip: {
            // valueSuffix: " km/h"
            enabled: false,
          },
          // colorByPoint: false,
          // pointInterval: 10
        },
      ],
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              if (this.y > 0) {
                const fontSize = this.y <= 2 ? '8px' : '14px';
                return `<b style="font-size: ${fontSize}">${this.y}%</b>`
              }
            },
            distance:isSectorFull? "-100%":"-12%",
            //fontSize: "14px",
          },
          size: "85%",
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
          borderWidth: 0,
          // showInLegend: true
          showInLegend: true,
        },
        series: {
          point: {
            events: {
              legendItemClick: function () {
                return false; // <== returning false will cancel the default action
              },
            },
          },
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      tooltip: {
        // padding: 16,
        // backgroundColor: "#FFF",
        // borderRadius: 8,
        // useHTML: true,
        // style: { color: "#000", fontFamily: "'Arial', sans-serif" },
        enabled: false,
      },
      legend: {
        padding: 15,
        enabled: isMobile ? false : true,
        floating: true,
        title: {
          text: "Colorado River Use",
          style: {
            font: "normal normal bold 16px Arial",
            color: "#2F2F2F",
          },
        },
        itemStyle: {
          color: "#333333",
          fontSize: "16px",
          fontWeight: "normal",
          fontFamily: "Arial",
        },
        //   align: "center",
        backgroundColor: "#FFFFFF",
        borderColor: "#E0E0E0",
        borderWidth: 1,
        borderRadius: 15,
        //   width: "25%",
        //   padding: 10,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        shadow: {
          offsetX: -1,
          offsetY: 3,
          color: "#00000029",
          width: 4,
        },
        align: "right",
        verticalAlign: "bottom",
        layout: "vertical",
        y: isMobile ? 150 : 0,
        symbolRadius: 0,
        //   reversed: true,
      },
    };
    setOptions(options_temp);
  }
  useEffect(setOptionFunc, [
    isMobile,
    windowSize,
    entity_entitlements,
    entitlement_year,
    city_metrics,
    city_selected,
    minimumAccess,
    maximumAccess,
  ]);

  const handleSliderChange = (e, value) => {
    setSliderEntitlementYear(value);
  };

  const handleSliderChangeCommited = (e, value) => {
    setEntitlementYear(value);
  };

  const handleChange = (value) => {
    // loadCityMetrics(value);
    loadCityMetrics(value);
    setSelectedCity(cities[value - 1]);
    loadEntityEntitlements(value, scenario_selected.value);
  };

  return (
    <>
      {!loggedIn && (
        <Box sx={{ pl: 8 }}>
          <CentralAZLocationFilter
            location_options={cities}
            handleChange={handleChange}
            isCurrentTabCitites={true}
            chart_name="colorado_river_water_access"
            dropdown="phoenix"
          />
        </Box>
      )}
      <Box className={classes.gaugePieContainer}>
        <Box className={classes.chartContainer}>
          {/* <Box> */}
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
        {isMobile && (
          <Grid
            className={classes.chartLegendContainer}
            style={{ marginRight: 0 }}
          >
            <Grid className={classes.chartLegend}>
              <Typography className={classes.legendTitle}>
                Colorado River Use
              </Typography>
              {options.series.length > 0 &&
                options.series[0].data.map((item, idx) => (
                  <Grid className={classes.legendItem}>
                    <Box
                      classes={{ root: classes.legendItemColor }}
                      style={{ backgroundColor: item.color }}
                    />
                    <Typography className={classes.legendItemText}>
                      {item.name}
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        )}
        <Box className={classes.sliderContainer}>
          {/* <ThemeProvider theme={theme}> */}
          <Typography className={classes.sliderLabel}>
            Colorado Water Access
          </Typography>
          <Slider
            value={slider_entitlement_year}
            min={sliderValues.min_value}
            max={sliderValues.max_value} // changes here
            marks={sliderValues.range}
            step={1}
            classes={{
              root: classes.citySlider,
              rail: classes.citySliderRail,
              trackInverted: classes.citySliderTrackInverted,
              track: classes.citySliderTrack,
              thumb: classes.citySliderThumb,
              mark: classes.citySliderMark,
              markLabel: classes.cityMarkLabel,
            }}
            onChange={handleSliderChange}
            onChangeCommitted={handleSliderChangeCommited}
            // track="inverted"
            valueLabelDisplay="on"
            getAriaValueText={valueLabelFormat}
            valueLabelFormat={valueLabelFormat}
            ValueLabelComponent={ValueLabelComponent}
          />
          {/* </ThemeProvider> */}
        </Box>
      </Box>
    </>
  );
}

export default GaugePie;
